import { AboutDialog, ComponentVersion } from '@h2oai/ui-kit';
import logo from '@h2oai/ui-kit/lib/assets/images/logo.svg';
import headerBackgroundImage from '@h2oai/ui-kit/lib/assets/images/modalBanner.png';
import React from 'react';

import { useQueryEnvironment, useQueryServices } from '../../discovery-service/discoveryService.hooks';

export interface HaicAboutModalProps {
  hidden?: boolean;
  onDismiss?: () => void;
}

export function HaicAboutModal(props: HaicAboutModalProps) {
  const environmentQuery = useQueryEnvironment();
  const environment = environmentQuery.data;

  const servicesQuery = useQueryServices();
  const services = servicesQuery.data?.services;

  const versionInfo = React.useMemo<string>(() => {
    const versionList = [];
    if (environment) {
      versionList.push(environment);
    }

    if (services) {
      versionList.push(...services);
    }

    return JSON.stringify(versionList);
  }, [environment, services]);

  const componentVersions = React.useMemo<ComponentVersion[]>(() => {
    if (!services) return [];
    return services
      .map((service) => {
        return {
          displayName: service.displayName ? service.displayName : service.name,
          version: service.version ? service.version : 'Unknown version',
        } as ComponentVersion;
      })
      .filter((value, index, self) => {
        return (
          value.displayName &&
          index === self.findIndex((t) => t.displayName === value.displayName && t.version === value.version)
        );
      })
      .sort((a, b) => (a.displayName || '').toLowerCase().localeCompare((b.displayName || '').toLowerCase()));
  }, [services]);

  return (
    <AboutDialog
      services={componentVersions}
      cloudVersion={environment?.h2oCloudVersion || ''}
      versionInfo={versionInfo}
      logoUrl={logo}
      licenceUrl={'/license/'}
      headerBackgroundImageUrl={headerBackgroundImage}
      hidden={props.hidden}
      onDismiss={props.onDismiss}
    />
  );
}
